function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "a05cc193-c29d-429b-b2bb-7a1787cc4de1",
  "data-name": "Fill-1",
  d: "M23.7,13.78a7.06,7.06,0,0,1,1.2,9.53l-.17.22,3.65,3.64a.86.86,0,0,1,.08,1.13l-.08.08a.86.86,0,0,1-1.13.08l-.08-.08-3.63-3.65-.06,0a7,7,0,0,1-8.6,0l-.22-.18a7,7,0,0,1,9-10.81Zm-4.52.05A5.34,5.34,0,0,0,19,24.51h.44a5.35,5.35,0,0,0,5.12-5.12v-.22A5.34,5.34,0,0,0,19.18,13.83Z"
});

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search.4444a3e2.svg";
export { ForwardRef as ReactComponent };